export const minecraft1218 = {
  version: '1.21.8',
  title: 'A Minecraft Movie',
  image: 'https://www.minecraft.net/content/dam/minecraftnet/games/minecraft/screenshots/1.21.7-1170x500.jpg',
  releases: [
    {
      id: "170hY7Zwl",
      version: "alpha-BetaTest-3-1.0.5",
      date: "Nov 23, 2025",
      changelog: "Versión alpha experimental BetaTest-3 para Minecraft 1.21.8. Agregado Resourcify para mejorar la descarga de Resource Packs, Data Packs, Worlds y Shaders. Varios mods actualizados a sus últimas versiones disponibles.",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/BetaTest-3-1.0.5-1.21.8",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: true
    },
    {
      id: "160hY6Zwl",
      version: "alpha-BetaTest-2-1.0.5",
      date: "Nov 17, 2025",
      changelog: "Versión alpha experimental BetaTest-2 para Minecraft 1.21.8. Actualizado Fabric Loader a 0.18.1. Agregado FastChest Revived para mejorar la carga de chunks y otras mejoras de gameplay. Varios mods actualizados a sus últimas versiones disponibles.",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/BetaTest-2-1.0.5-1.21.8",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: true
    },
    {
      id: "150hY5Zwl",
      version: "alpha-BetaTest-1-1.0.5",
      date: "Nov 16, 2025",
      changelog: "Versión alpha experimental BetaTest-1 para Minecraft 1.21.8 con nuevas características experimentales",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/BetaTest-1-1.0.5-1.21.8",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: true
    },
    {
      id: "140hY4Zwl",
      version: "1.0.4",
      date: "Jul 24, 2025",
      changelog: "Versión estable para Minecraft 1.21.8 con todos los mods actualizados y optimizados",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/1.0.4-1.21.8",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: false
    },
    {
      id: "130hY3Xwk",
      version: "beta-0.2-1.0.4",
      date: "Jul 24, 2025",
      changelog: "Segunda versión beta para Minecraft 1.21.8 con la mayoría de mods agregados",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/0.2-1.0.4-1.21.8",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: true
    },
    {
      id: "130hY3Xwk",
      version: "beta-0.1-1.0.4",
      date: "Jul 8, 2025",
      changelog: "Primera versión beta para Minecraft 1.21.8 con mods básicos optimizados",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/0.1-1.0.4-1.21.8",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: true
    }
  ]
};